import SelectOptin from './SelectOptin';

export default SelectOptin;